<template>
  <pt-bill-lot-operate class="pt-bill-lot-operate__page"></pt-bill-lot-operate>
</template>

<script>
import PtBillLotOperate from 'cps/trust-deed/pt-bill-lot-operate/withData'
export default {
  name: 'pt-bill-lot-operate__view',
  components: {
    'pt-bill-lot-operate': PtBillLotOperate
  }
}
</script>
